import { CUSTOMER_FORM } from '../form-customer-types';
import { displaySelectedValue } from '../../../dropdown';
import { IIndividualCustomer } from '../../../../models/customer.interface';

/**
 * Displays customer information on the customer form screen.
 * 
 * @param {IIndividualCustomer} awsData the customer information for AWS
 * 
 * @returns void
 */
const DisplayCustomerInformation = (awsData: IIndividualCustomer) => {
  const { customerName, accountNumber, limitGallonsAagCard, status, exportFileType, exportTo, partnerId } = awsData.body.customer[0];

  CUSTOMER_FORM.customerName.value = customerName;
  CUSTOMER_FORM.customerAccountNumber.value = accountNumber;
  CUSTOMER_FORM.customerGallonLimit.value = limitGallonsAagCard;
  CUSTOMER_FORM.customerStatus.value = String(status);
  CUSTOMER_FORM.customerFileType.value = exportFileType;

  displaySelectedValue('.aafp_list-partner', 'partner', partnerId.toString());
}

export default DisplayCustomerInformation;